export { default } from './firebase-analytics';
